/* 夏侯淵傳・第 1 章：傳饋相繼（建安五年，200）
 * 史實：《三國志·夏侯淵傳》「及與袁紹戰於官渡，行督軍校尉。紹破，使督兖、豫、徐州軍糧；時軍食少，淵傳饋相繼，軍以復振。」
 * 流程：大營的軍食一直在減。走到兗、豫、徐三座糧倉旁站定「開倉」，之後那座糧倉每隔一段時間就發一輛糧車往大營走。
 *       潰散的袁軍、盜賊會在路上攔車：敵人貼在車旁，車就停下、耐久下降，歸零被劫。送到 8 車「軍以復振」即勝利；軍食歸零失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, rout } from '../kit.ts';
import { cart, cartsTick, along, XTROOPS, F } from './xiahouyuan_kit.ts';
import { CAMP, DEPOTS, ROUTES } from '../maps/xiahouyuan_yanyu.ts';

const LV = 7, NEED = 8, EVERY = 18, DRAIN = 0.7, GAIN = 12, RAID = 11;
const NAMES = { yan: '兗州', yu: '豫州', xu: '徐州' };
const FOE = F(XTROOPS.yuan, '潰兵', 320, 16, 235);

export default {
  id: 'xiahouyuan-1', map: 'xiahouyuan_yanyu', hero: 'xiahouyuan',
  title: '第 1 章　傳饋相繼', year: '建安五年（200）',
  brief: {
    quote: [{ text: '紹破，使督兖、豫、徐州軍糧；時軍食少，淵傳饋相繼，軍以復振。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '官渡一戰，曹操以少勝多，但軍中的糧食也見底了。夏侯淵以督軍校尉的身分，督運兗、豫、徐三州的軍糧。',
    goals: ['到兗、豫、徐三座糧倉開倉發車', '護著糧車回大營，別讓潰兵劫走', `送到 ${NEED} 車，軍以復振`],
  },
  words: { ally: '曹軍', foe: '潰兵' },
  stars: [
    { text: '沒有糧車被劫', ok: (m) => !m.vars.lost },
    { text: '軍食一次也沒低於 20%', ok: (m) => m.vars.low >= 20 },
    { text: '150 秒內送到 8 車', ok: (m) => m.vars.doneT != null && m.vars.doneT < 150 },
  ],
  steps: [
    { // 1. 開倉、護送
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0]; me.y = CAMP[1] + 260;
        Object.assign(V, { food: 90, low: 90, got: 0, lost: 0, carts: [], open: {}, next: {}, raidT: 28, raids: [], t0: w.t });
        for (const k in DEPOTS) { const [x, y] = DEPOTS[k]; m.folk(x + 120, y - 60, { name: NAMES[k] + '倉', still: true, near: 1, draw: SG.campaignDraw.granary }); m.mark(k, x, y, NAMES[k] + '倉', true); }
        m.card('紹破，使督兖、豫、徐州軍糧。', '《夏侯淵傳》');
        m.line('夏侯淵', '大營快斷糧了。三州的糧倉都要開，一車接一車送上來！');
        m.after(4, () => m.line('提示', '站在糧倉旁不動就能開倉；開了的糧倉每隔一陣子發一輛車。潰兵貼著糧車，車就停下、被劫。糧倉與大營旁可以補給。'));
        m.obj('food', '');
        m.obj('got', '送到大營的糧車', NEED);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.food = Math.max(0, V.food - DRAIN * dt); V.low = Math.min(V.low, V.food);
        for (const k in DEPOTS) {
          const [x, y] = DEPOTS[k];
          if (!V.open[k]) { m.chanAt(me, k, x, y, 200, 1.5, '開倉', () => { V.open[k] = true; V.next[k] = 0; m.unmark(k); m.line('夏侯淵', `${NAMES[k]}倉開了，發車！`); }); continue; }
          if ((V.next[k] -= dt) <= 0) { V.next[k] = EVERY; V.carts.push(cart(m, x, y, { path: along(ROUTES[k]), from: k })); }
        }
        const r = cartsTick(m, w, dt, V.carts, 2.5);
        for (const c of r.arrived) { V.got++; V.food = Math.min(100, V.food + GAIN); w.fx({ k: 'puff', x: CAMP[0], y: CAMP[1] }); }
        for (const c of r.lost) { V.lost++; m.line('夏侯淵', `${NAMES[c.from]}的糧車被劫了！`); for (const u of w.units) if (u.alive && u.team === 1 && SG.gd(u.x, u.y, c.x, c.y) < 300) u.home = [c.x + (SG.rand() - 0.5) * 300, c.y + 200]; }
        V.carts = V.carts.filter((c) => !c.gone);
        // 潰兵攔車：挑一輛走在路上、離大營還遠的車，在它前面埋伏（同時最多兩夥）；一夥只剩一人就逃
        for (const g of V.raids) if (!g.fled && m.alive(g.list).length <= 1) { g.fled = true; rout(m, w, g.list, [g.p[0], g.p[1] + 900]); }
        V.raids = V.raids.filter((g) => m.alive(g.list).length);
        for (const g of V.raids) if (!g.fled) for (const u of m.alive(g.list)) { // 沒在打人就去搶車
          const c = V.carts.filter((c) => SG.gd(c.x, c.y, u.x, u.y) < 600).sort((a, b) => SG.gd(a.x, a.y, u.x, u.y) - SG.gd(b.x, b.y, u.x, u.y))[0];
          if (c && !(u.target && u.target.alive)) u.home = [c.x, c.y + 40];
        }
        if ((V.raidT -= dt) <= 0) {
          V.raidT = RAID;
          const on = V.carts.filter((c) => c.pi > 2 && c.pi < c.path.length - 4 && !c.held);
          if (on.length && V.raids.filter((g) => !g.fled).length < 2) {
            const c = on[Math.floor(SG.rand() * on.length)], p = c.path[Math.min(c.path.length - 2, c.pi + 3)];
            const list = [0, 1, 2].map((i) => { const u = m.foe('huangjin', p[0] + (i - 1) * 90 + 160, p[1] + 140 * (i % 2 ? 1 : -1), FOE); u.home = p.slice(); return u; });
            V.raids.push({ p, list });
          }
        }
        // 糧倉、大營旁邊可以補給（回生命、法力）
        if ([CAMP, ...Object.values(DEPOTS)].some(([x, y]) => m.near(me, x, y, 420))) { me.hp = Math.min(me.maxHp, me.hp + me.maxHp * 0.05 * dt); me.mp = Math.min(me.maxMp, me.mp + me.maxMp * 0.05 * dt); }
        m.get('food').text = `大營軍食：${Math.round(V.food)}%`;
        m.prog('got', V.got);
        if (V.food <= 0) { m.lose('軍食斷絕'); return false; }
        return V.got >= NEED;
      },
    },
    { // 2. 軍以復振
      enter(m, w) {
        m.vars.doneT = w.t - m.vars.t0;
        m.card('時軍食少，淵傳饋相繼，軍以復振。', '《夏侯淵傳》');
        for (const u of w.units) if (u.alive && u.team === 1) { u.home = [u.x + 2000 * (u.x < CAMP[0] ? -1 : 1), u.y + 400]; u.untargetable = true; }
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('夏侯淵陣亡'); },
};
